export enum ModelTypeKeys {
    UNIT = 'units',
    MEMBERSHIP = 'members',
    ORGANIZATION = 'organizations',
    FORM_SUBMISSION = 'submissions',
    VIOLATION = 'violations',
    VENDOR = 'vendors',
    USER = 'users',
}
